
if (!customElements.get('recommended-products')) {
  class RecommendedProducts extends HTMLElement {
    static observedAttributes = ['product-id', 'intent', 'limit', 'section-id'];
  
    connectedCallback() {
      this.loadRecommendations();
    }
  
    attributeChangedCallback() {
      if (this.isConnected) {
        this.loadRecommendations();
      }
    }
  
    async loadRecommendations() {
      const productId = this.getAttribute('product-id');
      const intent = this.getAttribute('intent') || 'related';
      const limit = this.getAttribute('limit') || 4;
      const sectionId = this.getAttribute('section-id');
  
      if (!productId || !sectionId) return;
  
      const cacheKey = `${productId}:${intent}:${limit}:${sectionId}`;
  
      if (this.dataset.cacheKey === cacheKey) return;
      this.dataset.cacheKey = cacheKey;
  
      const root = window.Shopify?.routes?.root || '/';
      const url = `${root}recommendations/products?product_id=${productId}&intent=${intent}&limit=${limit}&section_id=${sectionId}`;
  
      try {
        const response = await fetch(url);
  
        if (!response.ok) {
          throw new Error(`Recommended products failed: ${response.status}`);
        }
  
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newContent = doc.querySelector(`recommended-products[section-id="${sectionId}"]`);
  
        if (!newContent || !newContent.innerHTML.trim()) {
          this.innerHTML = '';
          this.closest('.shopify-section')?.remove();
          return;
        }
  
        this.innerHTML = newContent.innerHTML;
      } catch (error) {
        console.error(error);
        this.innerHTML = '';
      }
    }
  }
  customElements.define('recommended-products', RecommendedProducts);
}